import Component from './Component';
import Factory from '../common/Factory';

/**
 * 渲染要素的图片资源加载类.
 */
export default class ImageLoader extends Component {
    /**
     * 构造函数
     * @param {object<factory>} resourceFactory 资源管理器
     * @param {object} options 可选项
     */
    constructor(resourceFactory, options) {
        super(options);

        this.resourceFactory = resourceFactory;
    }

    /**
     * 用Promise对象实现的Ajax加载要素图片资源方法.
     * @param   {Array}   urls    图片的url地址列表
     * @returns {Promise} promise
     */
    load(urls) {
        if (!this.isValid()) {
            throw new Error('未绑定到地图对象/未初始化资管管理器');
        }

        return new Promise((resolve, reject) => {
            if (urls.length === 0) {
                resolve(0);
                return;
            }

            const promises = this._getPromises(urls);
            if (promises.length === 0) {
                resolve(0);
                return;
            }

            Promise.all(promises)
                .then((res) => {
                    this._addToResourceFactory(res);

                    resolve(res);
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    /**
     * 返回多个图片加载的Promise实例.
     * @returns {Array} promises - 返回多个图片加载的Promise实例
     */
    _getPromises(urls) {
        const promises = [];
        for (let i = 0; i < urls.length; ++i) {
            if(urls[i] instanceof Array) {
                for(let j = 0; j < urls[i].length; ++j) {
                    const url = urls[i][j];
                    if (!this.get(url)) {
                        promises.push(this._createPromise(url));
                    }
                }
            } else {
                const url = urls[i];
                if (!this.get(url)) {
                    promises.push(this._createPromise(url));
                }
            }

        }

        return promises;
    }

    /**
     * 生成图片请求的Promise.
     * 这里支持三种图片的加载，1：通过图片的url路径加载  2：通过图片的base64码加载  3：通过svg码加载
     * 备注：如果svg文件中包含中文需要对其转码， svgUrl = unescape(encodeURIComponent(svgUrl)
     * @param {string} url - 图片地址
     */
    _createPromise(url) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                const res = {
                    url: url,
                    image: image
                };
                resolve(res);
            };
            image.onerror = (e) => {
                const res = {
                    url: url,
                    image: null
                };
                resolve(res);
            };
            image.src = url;
        });
    }

    /**
     * 将加载的图片资源存储到图片资源管理器中.
     * @param {object} resources 图片资源对象列表
     */
    _addToResourceFactory(resources) {
        for (let i = 0; i < resources.length; ++i) {
            const resource = resources[i];
            this.resourceFactory.add(resource.url, resource.image);
        }
    }

    /**
     * 获取加载到的照片对象
     * @param {string} url
     * @returns 照片对象
     */
    get(url) {
        const vals = this.resourceFactory.get(url);
        if (vals.length > 0) {
            return vals[0];
        }

        return null;
    }

    /**
     * 组件是否可用
     * 只有绑定到具体的map对象上，并且初始化了资源管理器后才可用
     */
    isValid() {
        return super.isValid() && this.resourceFactory instanceof Factory;
    }
}
